// Compatibility re-export for @bitwarden/common/state-migrations
export * from "@bitwarden/state";
